import { InvoiceAPI } from "../api";
import { DocumentItem } from "./DocumentItem.class";
import { Receipt } from "./Receipt.class";
import moment from 'moment'
import Helper from "../plugins/Helper/Helper";
import Vue from "vue";
import i18n from '@/plugins/vue-i18n';
import store from "../store";
export class Invoice {
  constructor(data, isToMainCurrency, isRaw, isRawReceipt) {
    this.className = data.className
    this.objectId = data.objectId || data.id
    this.data = data
    this.isRaw = isRaw
    this.data = data
    this.isVatInclusive = data.isVatInclusive || false
    this.refInvoice = data.refInvoice
    this.refInvoiceBooking = data.refInvoiceBooking
    this.project = data.project
    this.market = data.market
    this.marketName = this.market ? this.market.name : ''
    this.contract = data.contract
    this.meterMonth = data.meterMonth
    this.meterYear = data.meterYear
    this.month = data.month
    this.year = data.year
    this.runningNumber = data.runningNumber
    this.documentId = data.documentId
    this.documentType = data.documentType
    this.companyData = data.companyData || {}
    this.customerData = data.customerData || {}
    this.date = data.date ? data.date.iso ? data.date.iso : data.date : null
    this.dueDate = data.dueDate ? data.dueDate.iso : null
    this.sentBy = data.sentBy
    this.note = data.note
    this.vatPercent = data.vatPercent || Vue.prototype.$globalVatPercent || 7
    this.isSent = data.isSent || false
    this.isPaid = data.isPaid || false
    this.isCancelled = data.isCancelled || false
    this.receipts = data.receipts || []
    this.isVat = data.isVat
    this.documentId1 = data.documentId1
    this.documentId2 = data.documentId2
    this.documentId3 = data.documentId3
    this.documentId4 = data.documentId4
    this.documentId5 = data.documentId5
    this.documentId6 = data.documentId6
    this.createdAt = data.createdAt ? data.createdAt : null
    this.tempTotalPaidValue = data.totalPaidValue || 0
    this.projectCode = data.projectCode || null
    this.createdBy = data.createdBy || null
    this.invoicePayment = data.invoicePayment
    this.booking = data.booking
    this.isViewed = data.isViewed
    this.contractCheckOuts = data.contractCheckOuts
    this.schedulerTask = data.schedulerTask
    this.areaBooking = data.areaBooking
    this.currencyCode = data.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
    this.currencyRate = data.currencyRate
    this.isBadDebt = data.isBadDebt || false
    let exchangeRate = 1
    if (isToMainCurrency && this.currencyCode != Vue.prototype.$globalCurrencyCode) {
      let dataCurrencyRate = this.currencyRate || store.getters["currencyRate/getLastCurrencyRate"]
      if (dataCurrencyRate) exchangeRate = dataCurrencyRate.data?.[this.currencyCode]?.[Vue.prototype.$globalCurrencyCode]?.value || 1
      this.currencyCode = Vue.prototype.$globalCurrencyCode || "THB"
      
      if (isRaw) {
          this.data.totalOriginalValue *= exchangeRate
          this.data.totalVatValue *= exchangeRate
          this.data.totalValue *= exchangeRate
          this.data.totalNonVatValue *= exchangeRate
          this.data.totalVatItemsValue *= exchangeRate
          this.data.totalNonVatItemsValue *= exchangeRate
          this.data.totalWhtValue *= exchangeRate
          this.data.totalDiscountValue *= exchangeRate
          this.data.totalPaidValue *= exchangeRate
          this.data.totalUnpaidValue *= exchangeRate
      }
      
      this.tempTotalPaidValue = Helper.round(this.tempTotalPaidValue * exchangeRate)
      this.currencyCode = Vue.prototype.$globalCurrencyCode || "THB"
    }
    this.splitType = data.splitType
    const items = data?.items?.filter(d => {
      const area = d.area ? d.area : { isRemove: true, name: "-" };
      d.area = area;
      return d;
    });
    this.items = [];
    this.areaName = "-"
    if (data.items && data.items.length) {
      let name = [];
      for (let item of items) {
        this.items.push(
          new DocumentItem(
            item,
            data.isVatInclusive,
            this.vatPercent,
            this.projectCode,
            null,
            exchangeRate
          )
        );

        if (item.area && item.area.name && item.area.name != "-") {
          name.push(item.area.name);
        }
      }
      this.areaName = [...new Set(name)].sort().join(",") || "-"
    } else {
      this.items.push(
        new DocumentItem(
          {},
          this.isVatInclusive,
          this.vatPercent,
          this.projectCode,
          null,
          exchangeRate
        )
      );
    }
    this.tels = [""];
    this.emails = [""];

    if (this.customerData) {
      this.tels = this.customerData?.tel?.split(",");
      this.emails = this.customerData?.email?.split(",");
      this.customerDataName = this.customerData.name
    }
    
    if(data.booking) {
      this.businessName = this.booking.businessName ? this.booking.businessName : '-'
    } 
    
    if(data.contract){
      this.businessName = data.contract.businessName ? data.contract.businessName : '-'
    }  
    this.receiptsId = this.receipts.map(d => d.documentId).join("\n");
    this.documentTypeString = data.documentType ? i18n.t(`bill.document_type.${data.documentType}`) : ""
    this.contractCustomerMarketId = this.contract && this.contract.customerMarketId ? this.contract.customerMarketId : '-'
    // this.penaltyDays = data.penaltyDays || 0
    // this.penalty = data.penalty
    this.penaltyItem = data.penaltyItem
    this.penaltyItems = data.penaltyItems
    this.isErrorBilling = false
    for (const item of this.items) {
      if (item.quantity < 0) {
        this.isErrorBilling = true
        break;
      }
    }
    this.contractAreas = ''
    if (this.contract && this.contract.areas) this.contractAreas = this.contract.areas.map(i => i.name).join(',')
    
    if (this.receipts && this.receipts.length && !isRawReceipt) this.receipts = this.receipts.map(receipt => new Receipt(receipt));

    this.contractIsConnect = this.contract && this.contract.customer && this.contract.customer.isConnected ? true : false
    this.booking = data.booking
    if (this.refInvoiceBooking?.length)
      this.refInvoiceBooking = this.refInvoiceBooking.map(item => new Invoice(item));

    this.order = ""
    if(this.contract && this.contract.areas){
      this.order = this.contract.areas.map(item => item.order || 0).sort((a, b) => a - b)[0] || ""
    }
  }
  static async getInvoicesByContract(payload) {
    const { data } = await InvoiceAPI.getInvoicesByContract(payload);
    let { projectId, marketId, contractId } = payload

    //Penalty
    let invoices = data.result
    if (contractId && invoices && invoices.length) {
      for (let invoice of invoices) {
        if (invoice.documentType == 1 && !invoice.date && !invoice.isSent && !invoice.isPaid && !invoice.editedAt && invoice.month && invoice.year && !invoice.schedulerTask) {
          let month = invoice.month, year = invoice.year;
          let diffInvoiceContract
          let monthYearMoment = moment(`${month}/${year}`, 'M/YYYY')
          let bfMonthYearMoment = monthYearMoment.add(-1, 'months')
          let bfMonth = bfMonthYearMoment.format('M')
          let bfYear = bfMonthYearMoment.format('YYYY')
          diffInvoiceContract = await InvoiceAPI.getPenaltyMonthlyInvoices(projectId, marketId, parseInt(bfMonth), parseInt(bfYear), [contractId])
          if (diffInvoiceContract && diffInvoiceContract.data && diffInvoiceContract.data.result) {
            let penaltyInvoiceContracts = diffInvoiceContract.data.result
            let currencyCode = invoice.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
            let penaltyKey = `${invoice.contract.objectId}_${currencyCode}`
            if (invoice.splitType) penaltyKey += `_${invoice.splitType}`
            if (penaltyInvoiceContracts[penaltyKey]) {
              let penaltyItems = []
              let penaltyInvoiceContract = penaltyInvoiceContracts[penaltyKey]
              for (let penaltyInvoiceContractIn of penaltyInvoiceContract) {
                let accountingProduct = penaltyInvoiceContractIn.accountingProduct
                let quantity = penaltyInvoiceContractIn.quantity
                let originalPricePerUnit = penaltyInvoiceContractIn.originalPricePerUnit
                let detail = penaltyInvoiceContractIn.detail || ''
                let whtPercent = penaltyInvoiceContractIn.whtPercent || 0
                let penaltyItem = new DocumentItem(
                  {
                    accountingProduct,
                    originalPricePerUnit,
                    quantity,
                    name: accountingProduct.name,
                    detail,
                    whtPercent,
                    sellVatType: accountingProduct.sellVatType,
                    unit: accountingProduct.unit,
                    type: accountingProduct.type
                  },
                  invoice.isVatInclusive,
                  invoice.vatPercent,
                  invoice.projectCode
                )
                penaltyItems.push(penaltyItem)
                invoice.items.push(penaltyItem);
              }
              invoice.penaltyItems = penaltyItems
            }
          }
        }
      }
    }
    return invoices.map(item => new Invoice(item));
  }
  static async getInvoicesBySchedulerTask(payload) {
    const { data } = await InvoiceAPI.getInvoicesBySchedulerTask(payload);
    // Array Return
    return data.result.map(item => new Invoice(item));
    // Object Return
    // return data.result = new Invoice(data.result)
  }
  static async getInvoicesByContractInAppeal(payload) {
    const { data } = await InvoiceAPI.getInvoicesByContractInAppeal(payload);
    // Array Return
    return data.result.map(item => new Invoice(item));
    // Object Return
    // return data.result = new Invoice(data.result)
  }
  static async getInvoicesRecognizanceByContract(payload) {
    const { data } = await InvoiceAPI.getInvoicesRecognizanceByContract(payload);
    // Array Return
    return data.result.map(item => new Invoice(item, payload.isToMainCurrency));
    // Object Return
    // return data.result = new Invoice(data.result)
  }
  static async createInvoice(payload) {
    const { data } = await InvoiceAPI.createInvoice(payload);
    // Array Return
    // return data.result.map((item) => new Invoice(item));
    // Object Return
    return new Invoice(data.result);
  }
  static async createBookingInvoice(payload) {
    const { data } = await InvoiceAPI.createBookingInvoice(payload);
    return new Invoice(data.result);
  }
  static async getMonthlyInvoices(projectId, marketId, month, year) {
    const { data } = await InvoiceAPI.getMonthlyInvoices(
      projectId,
      marketId,
      month,
      year
    );
    //Penalty
    let invoices = data.result
    if (invoices && invoices.length) {
      let diffInvoiceContract
      let contractIds = invoices.filter(invoice => !invoice.documentId).map(invoice => invoice.contract.objectId)
      let monthYearMoment = moment(`${month}/${year}`, 'M/YYYY')
      let bfMonthYearMoment = monthYearMoment.add(-1, 'months')
      let bfMonth = bfMonthYearMoment.format('M')
      let bfYear = bfMonthYearMoment.format('YYYY')
      if (contractIds && contractIds.length)
        diffInvoiceContract = await InvoiceAPI.getPenaltyMonthlyInvoices(projectId, marketId, parseInt(bfMonth), parseInt(bfYear), contractIds)
      if (diffInvoiceContract && diffInvoiceContract.data && diffInvoiceContract.data.result) {
        let penaltyInvoiceContracts = diffInvoiceContract.data.result
        for (let invoice of invoices) {
          let currencyCode = invoice.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
          let penaltyKey = `${invoice.contract.objectId}_${currencyCode}`
          if (invoice.splitType) penaltyKey += `_${invoice.splitType}`
          if (!invoice.date && !invoice.isSent && !invoice.isPaid && !invoice.editedAt && penaltyInvoiceContracts[penaltyKey] && !invoice.schedulerTask) {
            let penaltyInvoiceContract = penaltyInvoiceContracts[penaltyKey]
            let penaltyItems = []
            for (let penaltyInvoiceContractIn of penaltyInvoiceContract) {
              let accountingProduct = penaltyInvoiceContractIn.accountingProduct
              let quantity = penaltyInvoiceContractIn.quantity
              let originalPricePerUnit = penaltyInvoiceContractIn.originalPricePerUnit
              let detail = penaltyInvoiceContractIn.detail || ''
              let whtPercent = penaltyInvoiceContractIn.whtPercent || 0
              let penaltyItem = new DocumentItem(
                {
                  accountingProduct,
                  originalPricePerUnit,
                  quantity,
                  name: accountingProduct.name,
                  detail,
                  whtPercent,
                  sellVatType: accountingProduct.sellVatType,
                  unit: accountingProduct.unit,
                  type: accountingProduct.type
                },
                invoice.isVatInclusive,
                invoice.vatPercent,
                invoice.projectCode
              )
              penaltyItems.push(penaltyItem)
              invoice.items.push(penaltyItem);
            }
            invoice.penaltyItems = penaltyItems
          }
        }
      }
    }
    return invoices.map(item => new Invoice(item));
  }

  //Overall Invoice
  static async getOverAllInvoices(payload) {
    const { data } = await InvoiceAPI.getOverAllInvoices(payload);
    return data.result;
  }
  static async getOverAllMonthlyInvoices(payload) {
    const { data } = await InvoiceAPI.getOverAllMonthlyInvoices(payload);
    return data.result;
  }
  static async getOverAllYearlyInvoices(payload) {
    const { data } = await InvoiceAPI.getOverAllYearlyInvoices(payload);
    let res = {}
    for (const monthYear in data.result) {
      if (data.result[monthYear])
        res[monthYear] = data.result[monthYear].map(item => new Invoice(item));
    }
    return res
  }

  static async getInvoice(invoiceId, marketId) {
    const { data } = await InvoiceAPI.getInvoice(invoiceId);
    //Penalty
    let invoice = data.result
    if (invoice && invoice.contract && !invoice.documentId && !invoice.schedulerTask) {
      let monthYearMoment = moment(`${invoice.month}/${invoice.year}`, 'M/YYYY')
      let bfMonthYearMoment = monthYearMoment.add(-1, 'months')
      let bfMonth = bfMonthYearMoment.format('M')
      let bfYear = bfMonthYearMoment.format('YYYY')
      let diffInvoiceContract = await InvoiceAPI.getPenaltyMonthlyInvoices(invoice.project.objectId, marketId, parseInt(bfMonth), parseInt(bfYear), [invoice.contract.objectId])
      if (diffInvoiceContract && diffInvoiceContract.data && diffInvoiceContract.data.result) {
        let penaltyInvoiceContracts = diffInvoiceContract.data.result
        let currencyCode = invoice.currencyCode || Vue.prototype.$globalCurrencyCode || "THB"
        let penaltyKey = `${invoice.contract.objectId}_${currencyCode}`
        if (invoice.splitType) penaltyKey += `_${invoice.splitType}`
        if (!invoice.date && !invoice.isSent && !invoice.isPaid && !invoice.editedAt && penaltyInvoiceContracts[penaltyKey]) {
          let penaltyInvoiceContract = penaltyInvoiceContracts[penaltyKey]
          let penaltyItems = []
          for (let penaltyInvoiceContractIn of penaltyInvoiceContract) {
            let accountingProduct = penaltyInvoiceContractIn.accountingProduct
            let quantity = penaltyInvoiceContractIn.quantity
            let originalPricePerUnit = penaltyInvoiceContractIn.originalPricePerUnit
            let detail = penaltyInvoiceContractIn.detail || ''
            let whtPercent = penaltyInvoiceContractIn.whtPercent || 0
            let penaltyItem = new DocumentItem(
              {
                accountingProduct,
                originalPricePerUnit,
                quantity,
                name: accountingProduct.name,
                detail,
                whtPercent,
                sellVatType: accountingProduct.sellVatType,
                unit: accountingProduct.unit,
                type: accountingProduct.type
              },
              invoice.isVatInclusive,
              invoice.vatPercent,
              invoice.projectCode
            )
            penaltyItems.push(penaltyItem)
            invoice.items.push(penaltyItem);
          }
          invoice.penaltyItems = penaltyItems
        }
      }
    }
    return new Invoice(invoice);
  }

  static async updateInvoice(postData) {
    const { data } = await InvoiceAPI.updateInvoice(postData);
    return new Invoice(data.result);
  }

  static async updateInvoiceCustomerData(postData) {
    const { data } = await InvoiceAPI.updateInvoiceCustomerData(postData);
    return new Invoice(data.result);
  }

  static async sendInvoice({ id, date, dueDate }) {
    const { data } = await InvoiceAPI.sendInvoice({ id, date, dueDate });
    return new Invoice(data.result);
  }

  static async unsendInvoice(invoiceId) {
    const { data } = await InvoiceAPI.unsendInvoice(invoiceId);
    return new Invoice(data.result);
  }

  static async cancelInvoice(invoiceId) {
    const { data } = await InvoiceAPI.cancelInvoice(invoiceId);
    return new Invoice(data.result);
  }

  static async getInvoicesBetweenDateByProject(fromData) {
    const { data } = await InvoiceAPI.getInvoicesBetweenDateByProject(fromData);
    return data.result.map(item => new Invoice(item, fromData.isToMainCurrency, fromData.isRaw));
  }

  static async getInvoicesBetweenDateByMarket(fromData) {
    const { data } = await InvoiceAPI.getInvoicesBetweenDateByMarket(fromData);
    return data.result.map(item => new Invoice(item, fromData.isToMainCurrency, fromData.isRaw, true));
  }

  static async reCalculateMonthlyInvoice(invoiceId) {
    const { data } = await InvoiceAPI.reCalculateMonthlyInvoice(invoiceId);
    return data;
  }

  static async getInvoicesSentByContract(payload) {
    const { data } = await InvoiceAPI.getInvoicesSentByContract(payload);
    return data.result.map(item => new Invoice(item));
  }

  static async getUnpaidInvoicesByMarket(payload) {
    const { data } = await InvoiceAPI.getUnpaidInvoicesByMarket(payload);
    return data.result.map(item => new Invoice(item, payload.isToMainCurrency, payload.isRaw));
  }

  static async getUnpaidInvoicesByProject(fromData) {
    const { data } = await InvoiceAPI.getUnpaidInvoicesByProject(fromData);
    return data.result.map(item => new Invoice(item, fromData.isToMainCurrency, fromData.isRaw));
  }

  static async getBookingInvoicesByMarket(marketId) {
    const { data } = await InvoiceAPI.getBookingInvoicesByMarket(marketId);
    return data.result.map(item => new Invoice(item));
  }

  static async generateInvoiceItems(meterData) {
    const { data } = await InvoiceAPI.generateInvoiceItems(
      meterData
    );
    return data.result;
  }

  static async removeInvoice(invoiceId) {
    const { data } = await InvoiceAPI.removeInvoice(invoiceId);
    return data;
  }

  static async cancelInvoiceInvoicePayment(invoiceId) {
    const { data } = await InvoiceAPI.cancelInvoiceInvoicePayment(invoiceId);
    return new Invoice(data.result);
  }
  static async sendInvoices(payload) {
    const { data } = await InvoiceAPI.sendInvoices(payload);
    return data.result
  }

  get totalOriginalValue() {
    if (this.isRaw) {
      return this.data.totalOriginalValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalOriginalValue || 0), 0));
    }
  }

  get totalVatValue() {
    if (this.isRaw) {
      return this.data.totalVatValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalVatValue || 0), 0));
    }
  }

  get totalValue() {
    if (this.isRaw) {
      return this.data.totalValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalValue || 0), 0));
    }
  }

  get totalNonVatValue() {
    if (this.isRaw) {
      return this.data.totalNonVatValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalNonVatValue || 0), 0));
    }
  }

  get totalVatItemsValue() {
    if (this.isRaw) {
      return this.data.totalVatItemsValue;
    } else {
      return Helper.round(this.items.filter(d => {
        return d.sellVatType == 1;}).reduce((a, b) => a + (b.totalNonVatValue || 0), 0));
    }
  }

  get totalNonVatItemsValue() {
    if (this.isRaw) {
      return this.data.totalNonVatItemsValue;
    } else {
      return Helper.round(this.items.filter(d => {
        return d.sellVatType != 1;}).reduce((a, b) => a + (b.totalNonVatValue || 0), 0));
    }
  }

  get totalWhtValue() {
    if (this.isRaw) {
      return this.data.totalWhtValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalWhtValue || 0), 0));
    }
  }

  get totalDiscountValue() {
    if (this.isRaw) {
      return this.data.totalDiscountValue;
    } else {
      return Helper.round(this.items.reduce((a, b) => a + (b.totalDiscountValue || 0), 0));
    }
  }

  get status() {

    if (this.isCancelled) {
      return i18n.t('bill.cancel');
    } else if (this.isErrorBilling) {
      return i18n.t('bill.not_complete_bill');
    } else if (this.isBadDebt) {
      return i18n.t('bill.bad_debt');
    } else if (this.isPaid) {
      return i18n.t('payment.paid');
    } else if (this.isSent) {
      return i18n.t('payment.pending');
    } else if (this.documentId) {
      return i18n.t('bill.edit_bill');
    } else {
      return i18n.t('payment.wait_approval');
    }
  }

  get statusClass() {
    if (this.isCancelled) {
      return {
        class: 'grey--text',
        color: 'rgb(240,242,246)',
        text: i18n.t('bill.cancel')
      };
    } else if (this.isErrorBilling) {
      return {
        class: 'grey--text',
        color: 'rgb(240,242,246)',
        text: i18n.t('bill.not_complete_bill')
      };
    } else if (this.isBadDebt) {
      return {
        class: 'white--text',
        color: 'rgb(63, 63, 70)',
        text: i18n.t('bill.bad_debt')
      };
    } else if (this.isPaid) {
      return {
        class: 'green--text',
        color: 'rgb(209,242,225)',
        text: i18n.t('payment.paid')
      };
    } else if (this.isSent) {
      return {
        class: 'red--text',
        color: 'rgb(248,218,218)',
        text: i18n.t('payment.pending')
      };
    } else if (this.documentId) {
      return {
        class: 'orange--text',
        color: 'rgb(241,151,50,0.2)',
        text: i18n.t('bill.edit_bill')
      };
    } else {
      return {
        class: 'grey--text',
        color: 'rgb(240,242,246)',
        text: i18n.t('payment.wait_approval')
      };
    }

  }

  get totalPaidValue() {
    if (this.isPaid) return this.totalValue
    else return this.tempTotalPaidValue
  }

  get totalUnpaidValue() {
    if (this.isSent) return Helper.round(this.totalValue - this.totalPaidValue);
    else return 0;
  }

  get createdByFullName() {
    if (this.createdBy)
      return `${this.createdBy.firstName || ""} ${this.createdBy.lastName ||
        ""}`;
    else return "";
  }
}
